import { distinctUntilChanged, map } from 'rxjs/operators';
import { TooltipLayer } from 'www/modules/tooltip/tooltip-layer'
class EmailAlertsTooltip extends TooltipLayer {
    constructor(tooltipApi) {
        super(tooltipApi);
        this._hasSection = null;
        this._contentEl = null;
        this._topicEl = null;
        this._textEl = null;
        this._api = null;
        this._showCloseButton = false;
    }
    init() {
        super.init();
        this.el.classList.add('medscape-email-alerts-tooltip');
        this.el.appendChild(this.contentEl);
        this.initSubscriptions();
    }
    initSubscriptions() {
        if (this.api != null) {
            this.state
                .pipe(
                    map(state => {
                        return {
                            topicName: state.conceptName || state.sectionName
                        }
                    }),
                    distinctUntilChanged(null, state => {
                        return state.topicName;
                    })
                )
                .subscribe(state => {
                    this.handleTopicNameChange(state.topicName);
                })
            this.state.pipe(
                map(state => {
                    return {
                        hasSection: state.sectionId != null
                    }
                }),
                distinctUntilChanged(null, state => {
                    return state.hasSection;
                })).subscribe(state => {
                    this.handleSectionChange(state.hasSection)
            })
        }
    }
    get state(){
        return this.api.state;
    }
    get api() {
        return this._api;
    }

    set api(api) {
        this._api = api;
    }
    get hasSection() {
        if (this._hasSection == null) {
            this._hasSection = typeof(window.sectionId) !== "undefined";
        }
        return this._hasSection;
    }
    get tooltipText(){
        if (this.state.sectionId!=null) {
            return "Receive email when new articles are published from"
        }
        else{
            return "Receive email when new articles are published on"
        }
    }
    get topicName(){
        return this.state.conceptName || this.state.sectionName
    }
    get contentEl() {
        if (this._contentEl == null) {
            let contentEl = document.createElement('div');
            contentEl.classList.add('content-container');
            contentEl.innerHTML = `
                <span class="text"></span>
                <span class="topic"></span>
            `;
            this._contentEl = contentEl;
        }
        return this._contentEl;
    }
    get topicEl() {
        if (this._topicEl == null) {
            this._topicEl = this.contentEl.querySelector('.topic');
        }
        return this._topicEl;
    }
    get textEl() {
        if (this._textEl == null) {
            this._textEl = this.contentEl.querySelector('.text');
        }
        return this._textEl;
    }
    handleTopicNameChange(topicName=""){
        this.topicEl.innerHTML = topicName;
    }
    handleSectionChange(hasSection=this.state.hasSection){
        this.textEl.innerHTML = this.tooltipText;
    }


}

export { EmailAlertsTooltip }